module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule",
    class: {
      'schedule--preview': _vm.isPreview
    }
  }, [(_vm.isPreview) ? _c('div', {
    staticClass: "main-container",
    style: ({
      width: _vm.previewWidth
    })
  }, [_c('div', {
    staticClass: "main-container__card"
  }, [_c('div', {
    staticClass: "main-container__card__header"
  }, [_c('p', {
    staticClass: "title_template"
  }, [_vm._v(_vm._s(_vm.previewTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "iframe-container",
    style: ({
      width: _vm.previewWidth,
      height: _vm.previewHeight
    })
  }, [(_vm.currentSrc) ? _c('iframe', {
    staticClass: "current-template",
    attrs: {
      "src": _vm.iframeSrc
    }
  }) : _vm._e()])])]) : (_vm.currentSrc) ? _c('iframe', {
    staticClass: "current-template",
    attrs: {
      "src": _vm.iframeSrc
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a08b5b66","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppSchedule/Schedule.vue
// module id = 369
// module chunks = 1 2 3